$(function() {
  $('body').on('bless', function(e) {
    var $target = $(e.target)

    var $lockedInputs = $target.is('.form-element--locked')
      ? $target
      : $target.find('.form-element--locked')

    $lockedInputs.each(function() {
      var $input = $(this),
        $hiddenInput = $input.siblings('[type="hidden"]'),
        $formGroup = $input.parents('.form-group'),
        $editButton = $(
          '<button class="button button--unlock" type="button">Edit</button>',
        )

      $editButton.on('click', function() {
        $input.prop('readonly', false).focus()
        $input[0].select()
        $formGroup.removeClass('form-group--locked')
        $(this).remove()
      })

      $input.on('change', function() {
        $hiddenInput.val($(this).val())
      })

      $formGroup.addClass('form-group--locked').append($editButton)
    })
  })
})
